import React, { useState } from 'react';
import './Availability.css';

interface AvailabilityHeatMapProps {
  availabilityData: any;
}

const AvailabilityHeatMap: React.FC<AvailabilityHeatMapProps> = ({
  availabilityData
}) => {
  const years = Object.keys(availabilityData || {});
  const [activeYear, setActiveYear] = useState(years[0]);

  if (!availabilityData) {
      return <div className="no-availability">No availability data provided</div>;
  }

  
  if (years.length === 0) {
      return <div className="no-availability">No availability periods found</div>;
  }
      
  const months = [
      'january', 'february', 'march', 'april', 'may', 'june', 
      'july', 'august', 'september', 'october', 'november', 'december'
  ];
  
  const getColorForPercentage = (percentStr: any) => {
    if (!percentStr) return '#f5f5f5';

    const percent = typeof percentStr === 'string' ? 
        parseInt(percentStr.replace('%', ''), 10) : 0;

    if (isNaN(percent)) return '#f5f5f5';

    const saturation = 95;
    const lightness = 75;

    const hue = Math.round((percent / 100) * 120);

    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  };
  
  return (
    <div className="availability-heatmap">
      <div className="heatmap-tabs">
        {years.map(year => (
          <button 
            key={year}
            className={`heatmap-tab ${year === activeYear ? 'active' : ''}`}
            onClick={() => setActiveYear(year)}
          >
            {year}
          </button>
        ))}
      </div>
      
      <div className="heatmap-grid">
        <div className="heatmap-header">
          {months.map(month => (
            <div key={month} className="heatmap-header-cell">
              {month.charAt(0).toUpperCase() + month.slice(1, 3)}
            </div>
          ))}
        </div>
        
        <div className="heatmap-row">
          {months.map(month => {
            const yearData = availabilityData?.[activeYear] || {};
            const percentValue = yearData[month] || '0%';
            const bgColor = getColorForPercentage(percentValue);
            
            const percentNum = typeof percentValue === 'string' ? 
              parseInt(percentValue.replace('%', ''), 10) : 0;
            const textColor = !isNaN(percentNum) && percentNum > 44 ? '#000' : '#fff';
            
            return (
              <div 
                key={month} 
                className="heatmap-cell"
                style={{ 
                  backgroundColor: bgColor,
                  color: textColor
                }}
              >
                {percentValue}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AvailabilityHeatMap;